import Icon from '../components/Icon.vue'

Icon.register({
  om: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M360.6 60.9l-21.6-21.6c-1.7-1.7-3.1-5-3.1-7.4s1.4-5.7 3.1-7.4l21.6-21.6c4.1-4.1 10.7-4.1 14.8 0l21.6 21.6c1.7 1.7 3.1 5 3.1 7.4s-1.4 5.7-3.1 7.4l-21.6 21.6c-1.7 1.7-5 3.1-7.4 3.1-2.4 0-5.7-1.4-7.4-3.1zM412.1 192c55.1 0 99.9 44.8 99.9 99.9v100.1c0 48.5-47.5 88-96 88-96 0-96-64-96-64v-37.9c0-7.6 9.4-10.9 14.2-5 15.1 18.6 42.4 42.9 81.8 42.9 13.2 0 32-10.8 32-24v-100.1c0-19.8-16.1-35.9-35.9-35.9-9.6 0-18.6 3.7-25.4 10.5l-24.3 24.3c-18.9 18.9-44 29.3-70.6 29.3h-21.7c11 18.9 17.8 40.6 17.8 64 0 70.6-57.4 128-128 128-118.8 0-160-96-159.9-150.8 0-8.8 10.3-12.8 14.8-5.2 22.8 38 49.1 92 145.2 92 35.3 0 64-28.7 64-64s-28.7-64-64-64h-33c-5.6-0.5-10.6-3.5-13.2-8.5l-16.1-32.2c-5.4-10.7 2.4-23.3 14.4-23.3h31.9c26.5 0 48-21.5 48-48s-21.5-48-48-48c-11.3 0-21.8 3.8-30.3 10.7-5.5 4.5-13.5 4.5-19.2 0.2l-26.1-19.6c-8.1-6.1-8.5-18-1.1-24.9 25.1-23.7 59.9-34.7 96-28.8 43.2 7.1 79.4 40.6 89.5 83.2 6.4 27.1 2.8 53.1-7.7 75.2h46.8c9.6 0 18.6-3.7 25.4-10.5l24.3-24.3c18.9-18.9 44-29.3 70.6-29.3zM454.3 67.3c10.6-8 25.7-0.5 25.7 12.7v35.5c0 2.4-0.5 4.7-1.5 6.8-3 6.3-21.8 37.7-101.8 37.7-78.4 0-117.2-69.4-118.8-72.3-3.6-6.6-2.1-14.9 3.7-19.8 5.7-4.9 14.1-5.2 20.1-0.5 3.5 2.7 87 65.1 172.6-0.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/om.js
// module id = 1598
// module chunks = 0